import { render, staticRenderFns } from "./AkStockProductRelation.vue?vue&type=template&id=d4456b26&"
import script from "./AkStockProductRelation.vue?vue&type=script&lang=js&"
export * from "./AkStockProductRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4456b26')) {
      api.createRecord('d4456b26', component.options)
    } else {
      api.reload('d4456b26', component.options)
    }
    module.hot.accept("./AkStockProductRelation.vue?vue&type=template&id=d4456b26&", function () {
      api.rerender('d4456b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkStockProductRelation.vue"
export default component.exports